import {compose, equal, find, identity, immutableUpdate, memoizeHashed, memoizeSimple, property} from "./voidash";

const extractNested = locate => obj => {
  let found = null;
  immutableUpdate(obj, locate({ $invoke: nested => { found = nested; return nested; } }))
  return found;
};

class TreeStoreBase {
  getNode() {
    return this.root;
  }

  lbl(label) {
    this.getNode().lbl(label);
    return this;
  }

  get() {
    return this.root.get();
  }

  property = memoizeSimple(key => {
    const node = this.root.t(property(key)).lbl(`property ${key}`);
    const locate = a => ({ [key]: a });
    return new SubTreeStore(this, node, locate);
  });

  find(pred) {
    const node = this.root.t(arr => find(arr, pred)).lbl("find");
    const locate = a => ({ $find: [pred, a] });
    return new SubTreeStore(this, node, locate);
  }

  findByProperty = memoizeHashed((prop, val) => {
    return this.find(compose(equal(val), property(prop))).lbl(`find ${prop}=${val}`);
  }, (prop, val) => prop.replace(/(\s)/g, " $1") + "# #" + String(val).replace(/(\s)/g, " $1"))
}

class SubTreeStore extends TreeStoreBase {
  constructor(parent, node, locate) {
    super();
    this.parent = parent;
    this.root = node;
    this.locate = locate;
  }

  set(value, ...args) {
    return this.parent.update(this.locate({ $set: value }), ...args);
  }

  modify(fn, ...args) {
    return this.parent.update(this.locate({ $invoke: fn }), ...args);
  }

  update(updates, ...args) {
    return this.parent.update(this.locate(updates), ...args);
  }
}

export default class TreeStore extends TreeStoreBase {
  constructor(root, locateBase = identity) {
    super();
    this.root = root.graph.createSource(root.get()).lbl("TreeStore proxy");
    this.proxyPipe = null;
    this.reset(root, locateBase);
  }

  set(value) {
    if (this.locate === identity) this.rootOrig.set(value);
    else this.update({ $set: value });
  }

  modify(fn) {
    if (this.locate === identity) this.rootOrig.modify(fn);
    else this.update({ $invoke: fn });
  }

  update(updates) {
    this.rootOrig.modify(root => immutableUpdate(root, this.locate(updates)));
  }

  reset(root, locateBase = identity) {
    if (this.proxyPipe) {
      this.proxyPipe.deactivate();
      this.root.removePredecessor(this.proxyPipe);
    }
    this.rootOrig = root;
    this.locate = locateBase;
    this.proxyPipe = this.rootOrig
      .t(extractNested(this.locate)).lbl("TreeStore extractNested")
      .pipe(this.root);
  }
}
